import axios from '../javascript/custom-axios'
const RESOURCE_NAME = 'idea'

export default {
  getIdeasForJury(page=1,pageSize=100) {
    return axios.get(`${RESOURCE_NAME}/getForJury`, { params: { page: page, pageSize:pageSize} })
  }
}